export default class FrontStockProduct {
    id: number;
    // shelfCost: number;
    storeId: number;
    storeName: string;
    productSku: string;
    // beginDeductionTime?: Date;
    creationTime: Date;
    //deductIntegral: number;
    //deductionCycle: string;
    isCheckBy?: boolean;
    lastModificationTime?: Date;
    logisticsNumber: string;
    packageNums: number;
    productImgGuid: string;
    //productLink: string;
    productName: string;
    //productNums: number;
    productType: number;
    //purchaseCost: string;
    userCode: string;
    remark: string;
    checkTime?: Date;
    productStatus: number;
    totalStorage: number;
    totalOutgoing: number;
    inventory: number;
    shelfPosition: string;
    headFee: number;
}